import { render, staticRenderFns } from "./ASorRbuItemModuleGroup.vue?vue&type=template&id=c0554742"
import script from "./ASorRbuItemModuleGroup.vue?vue&type=script&lang=js"
export * from "./ASorRbuItemModuleGroup.vue?vue&type=script&lang=js"
import style0 from "./ASorRbuItemModuleGroup.vue?vue&type=style&index=0&id=c0554742&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports